import React, { useState, useEffect } from "react";
import "./Countdown.css"; // Import the CSS file
import { FundraiserResponse } from "../../Interfaces/Fundraiser";
import { isLightBackground } from "../../CommonFunctions";

type CountdownProps = {
  targetTimestamp: number; // Unix timestamp in milliseconds
  fundraiser: FundraiserResponse;
};

const Countdown: React.FC<CountdownProps> = ({
  targetTimestamp,
  fundraiser,
}) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const pstNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
    const difference = targetTimestamp - pstNow.getTime();

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    const totalSeconds = Math.floor(difference / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  };
  const primaryIsLight: boolean = isLightBackground(
    fundraiser.primary_color || "#FFFFFF"
  );

  const fundraiserCountdownDisplayStyles = {
    "--countdown-display-bg": fundraiser.primary_color
      ? fundraiser.primary_color
      : "#FFFFFF",
    "--cowndown-text-display": primaryIsLight ? "#000000" : "#FFFFFF",
    "--number-countdown-color": fundraiser.primary_color
      ? fundraiser.secondary_color
      : "#b81d1d",
  } as React.CSSProperties;

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timerId);
  }, [targetTimestamp]);

  return (
    <div
      className="countdown-container"
      style={fundraiserCountdownDisplayStyles}
    >
      <div className="countdown-text-container">Time Left to Purchase:</div>
      <div className="countdown-countdown-container">
        <div className="countdown-time-unit">
          <div className="countdown-time-value">{timeLeft.days}</div>
          <div className="countdown-time-label">Days</div>
        </div>
        <div className="countdown-time-unit">
          <div className="countdown-time-value">{timeLeft.hours}</div>
          <div className="countdown-time-label">Hours</div>
        </div>
        <div className="countdown-time-unit">
          <div className="countdown-time-value">{timeLeft.minutes}</div>
          <div className="countdown-time-label">Minutes</div>
        </div>
        <div className="countdown-time-unit">
          <div className="countdown-time-value">{timeLeft.seconds}</div>
          <div className="countdown-time-label">Seconds</div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
